<template>
  <div id="SignatureComponent">
    <v-checkbox
      v-model="saved"
      :rules="Rules.required"
      style="display: none"
      required
    />
    <vueSignature
      ref="signature"
      class="bordered mb-4"
      :class="invalid"
      :h="'200px'"
      :sig-option="option"
      :disabled="disabled"
    />
    <div class="d-sm-inline-flex">
      <span>Use the mouse or touchscreen to sign your name inside the dashed area above. {{ additionalText }}</span>
      <v-spacer class="mr-4" />
      <v-btn
        color="agency-color-secondary"
        class="mr-4"
        tile
        outlined
        :disabled="disabled || loading"
        @click="clear"
      >
        Clear
      </v-btn>
      <v-btn
        color="agency-color-secondary"
        class="mr-4"
        tile
        outlined
        :disabled="disabled || loading"
        @click="undo"
      >
        Undo
      </v-btn>
      <v-btn
        color="agency-color-primary"
        tile
        :disabled="disabled"
        :loading="loading"
        @click="save"
      >
        Save
      </v-btn>
    </div>
  </div>
</template>
<script>
import vueSignature from 'vue-signature'
export default {
  name: 'SignatureComponent',
  components: {
    vueSignature
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: true
    },
    additionalText: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      valid: true,
      saved: false,
      option: {
        penColor: 'rgb(0, 0, 0)',
        backgroundColor: 'rgb(255,255,255)'
      }
    }
  },
  computed: {
    invalid () {
      return this.valid ? '' : 'bordered-red'
    }
  },
  created () {
    //
  },
  methods: {
    save () {
      var context = this
      if (!this.isEmpty()) {
        var png = context.$refs.signature.save()
        context.$emit('signatureSaved', png)
        context.valid = true
        context.disabled = true
        context.saved = true
      } else {
        context.valid = false
      }
    },
    clear () {
      var context = this
      context.$refs.signature.clear()
      context.redraw()
    },
    undo () {
      var context = this
      context.$refs.signature.undo()
    },
    isEmpty () {
      var context = this
      return context.$refs.signature.isEmpty()
    },
    redraw () {
      var context = this
      var canvas = document.getElementById(context.$refs.signature.uid)
      var ratio = Math.max(window.devicePixelRatio || 1, 1)
      canvas.width = canvas.offsetWidth * ratio
      canvas.height = canvas.offsetHeight * ratio
      canvas.getContext('2d').scale(ratio, ratio)
    }
  }
}
</script>
<style lang='scss'>
#SignatureComponent {
  .bordered {
    border: 2px dashed rgba(0,0,0,.38);
  }
  .bordered-red {
    border-color: red;
  }
}
</style>
